import React, { useState } from "react";
import classNames from "classnames";
import Navigation from "components/Navigation";
import UserReportsTable from "./components/UserReportsTable";
import JobPostReportsTable from "./components/JobPostReportsTable";
import UserBlocksTable from "./components/UserBlocksTable";
import JobPostBlocksTable from "./components/JobPostBlocksTable";

import "./ModerationPage.styles.scss";

type ModerationPageProps = {
  className?: string;
};

type Tab = "user-reports" | "job-post-reports" | "user-blocks" | "job-post-blocks";

const TABS: { id: Tab; label: string }[] = [
  { id: "user-reports", label: "User reports" },
  { id: "job-post-reports", label: "Job post reports" },
  { id: "user-blocks", label: "User blocks" },
  { id: "job-post-blocks", label: "Job post blocks" },
];

const ModerationPage = (props: ModerationPageProps) => {
  const { className } = props;
  const classes = classNames("anys-moderation-page", className);

  const [tab, setTab] = useState<Tab>("user-reports");

  return (
    <div className={classes}>
      <Navigation />

      <div className="anys-moderation-page__content">
        <div className="anys-moderation-page__tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              className={classNames("anys-moderation-page__tabs__btn", {
                "anys-moderation-page__tabs__btn--active": tab === t.id,
              })}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === "user-reports" && <UserReportsTable />}
        {tab === "job-post-reports" && <JobPostReportsTable />}
        {tab === "user-blocks" && <UserBlocksTable />}
        {tab === "job-post-blocks" && <JobPostBlocksTable />}
      </div>
    </div>
  );
};

export default ModerationPage;
